import { Box, Grid, Typography, useTheme } from '@mui/material';
import DefaultLogo from '@shared/assets/air/iconBlack.png';
import { convertToCamelCase } from '@shared/helpers';

import BaggageItem from './BaggageItem';

import { sxStyled } from '../styles';

const CustomCarrier = ({ carrier = {}, common_title = {}, activeRadio }) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  return (
    <Box sx={sxStyle.boxCarrier}>
      <Typography sx={{ color: '#000', fontWeight: 700, textAlign: 'center' }}>
        Aerolinea
      </Typography>
      <Grid container sx={sxStyle.gridCarrier}>
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            component="img"
            sx={sxStyle.airlineLogo}
            src={carrier.logo || DefaultLogo}
            alt="aerolineas"
          />

          <Typography sx={sxStyle.carrierName}>
            {convertToCamelCase(carrier.description || carrier.code)}
          </Typography>
        </Grid>
      </Grid>
      <Grid container sx={sxStyle.gridContainerBagg}>
        <BaggageItem
          titleObj={common_title[0]}
          flight={activeRadio[0]}
          common_title={common_title}
        />
        {common_title[1] && (
          <BaggageItem
            titleObj={common_title[1]}
            flight={activeRadio[1]}
            common_title={common_title}
          />
        )}
      </Grid>
    </Box>
  );
};

export default CustomCarrier;
